





















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import { TranslateResult } from 'vue-i18n';

@Component
export default class UiPopupComponent extends Vue {
  @Prop()
  public value: boolean = false;

  @Prop()
  public title: TranslateResult;

  @Prop({
    default: true
  })
  public backdrop: boolean;

  @Prop({
    default: false
  })
  public showImage: boolean;

  public imageSource: string;

  @Prop()
  public showButtons: boolean;

  @Prop({
    default: true
  })
  public showCancelButton: boolean;

  @Prop({
    default: i18n.t('player.ok')
  })
  public buttonPrimaryLabel: TranslateResult;

  @Prop({
    default: true
  })
  public closable: boolean;

  public shows: boolean = this.value;

  @Watch('value')
  public onValueChanged(newValue: boolean): void {
    this.shows = newValue;
  }

  public close(): void {
    if (!this.closable) {
      return;
    }

    this.shows = false;
    this.emitInput(false);
  }

  @Emit('input')
  public emitInput(value: boolean): boolean {
    return value;
  }

  @Emit('button-clicked')
  public emitButtonClicked(): void {

  }

  public t(key: string): TranslateResult {
    return i18n.t(key);
  }
}
